// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"1c7a0ecd","72":"a066d182","98":"381dd984","228":"71492044","305":"8d7aff00","326":"fc92be0f","357":"21b10b11","378":"89108a06","729":"3ae8c857","739":"81888a58","747":"062030d0","787":"974ca11b","792":"7fc70dab","937":"56720bbf"}[chunkId] + ".chunk.js";
};